import { Button, TextField, Input, Select, Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import React, { useEffect, useState }from 'react';
import './App.css';
import styles from "./style.module.css";

// =============================================================
// 各種設定値

// カレンダーを動的に表示させるための関数
var calanderStartDate = 10;
var calanderEndDate = 30;

// Airtable各種設定
var airtableAPIKEY = 'keyUSiXeg3j4HrDx0';
var airtableBaseId = 'apphPBXDqjOc6Pw8Q';
var airtableTable = 'TOP_ヘルメット治療患者一覧';
var airtableView = '名越用';
var airtableTableRecipe = '3_造形条件管理';
var airtableViewPecipe = 'レシピ一覧';

// =============================================================



// Airtable API Authentication
var Airtable = require('airtable');
var base = new Airtable({apiKey: airtableAPIKEY}).base(airtableBaseId);

// material UI
const useStyles = makeStyles({
    root: {
      backgroundColor: 'red',
      color: props => props.color,
    },
});

//納品日ラベル
function LabelDeliver() {
    const label = document.createElement('div');
    label.className = styles.red +  ' ' + styles.label + ' ' + 'deliver';
    label.innerHTML = '納品';
    return label;
}

// 造形日ラベル
function LabelPrint(number) {
    const label = document.createElement('div');
    if(number === 1){
        label.className = styles.blue +  ' ' + styles.label + ' ' + 'print';
        label.innerHTML = '造１';
    }else if(number === 2){
        label.className = styles.skyblue +  ' ' + styles.label + ' ' + 'print';
        label.innerHTML = '造２';
    }else{
        label.className = styles.blue +  ' ' + styles.label + ' ' + 'print';
        label.innerHTML = '造形';
    }
    return label;
}

// 磨き日ラベル
function LabelPolish() {
    const label = document.createElement('div');
    label.className = styles.yellow +  ' ' + styles.label + ' ' + 'polish';
    label.innerHTML = '磨き';
    return label;
}

// 移動ラベル
function LabelTransfer() {
    const label = document.createElement('div');
    label.className = styles.grey +  ' ' + styles.label + ' ' + 'transfer';
    label.innerHTML = '移動';
    return label;
}

// クッションラベル
function LabelFoam() {
    const label = document.createElement('div');
    label.className = styles.green +  ' ' + styles.label + ' ' + 'foam';
    label.innerHTML = '貼り';
    return label;
}

// 染色ラベル
function LabelColoring() {
    const label = document.createElement('div');
    label.className = styles.pink +  ' ' + styles.label + ' ' + 'coloring';
    label.innerHTML = '染色';
    return label;
}

// カレンダー用0埋め
function toDoubleDigits(num) {
    num += "";
    if (num.length === 1) {
      num = "0" + num;
    }
   return num;     
}


// 動的日付取得用
// 本日の10日前～30日後の日付を取得する使用になっている
function rangeDateSet(){
    var start = new Date();
    var end = new Date();
    start.setDate(start.getDate() - calanderStartDate);
    var startDateStr = String(start.getFullYear() + '-' + toDoubleDigits(start.getMonth() + 1) + '-' + toDoubleDigits(start.getDate()));
    end.setDate(end.getDate() + calanderEndDate);
    var endDateStr = String(end.getFullYear() + '-' + toDoubleDigits(end.getMonth() + 1) + '-' + toDoubleDigits(end.getDate()));
    return [startDateStr, endDateStr]
}

// 今後以下コードを読む人へのお詫び
// useStateのうまい受け渡し方法が分からなかったため、メイン関数内に全てのぶち込んでます。
// ゆえにめちゃくちゃ汚いコードになってしまっております。いい感じに書き換えてください。
// 名越

function App() {
    const [show, setShow] = useState(false);
    const [customer, setCustomer] = useState([]);
    const [id, setId] = useState(0);   
    const [date, setDate] = useState('2020-01-01');  
    const [ampm , setAmpm] = useState('AM');  
    const [updatedate, setUpdatedate] = useState(); 
    const [startDate, setStartDate] = useState(String(rangeDateSet()[0]));  
    const [endDate, setEndDate] = useState(String(rangeDateSet()[1]));  
    const [query, setQuery] = useState(0);
    const day = new Date();
    const today = String(day.getFullYear() + "-" + toDoubleDigits(day.getMonth()+1) + "-" + toDoubleDigits(day.getDate())); 
    const [signin, setSignin] = useState(null); 
    const classes = useStyles();
    const [showRecipe, setShowRecipe] = useState('close');
    const [selectId, setSelectId] = useState([]);
    const [multipleSelect, setMultipleSelect] = useState(false);
    const [selectRecipe, setSelectRecipe] = useState(false);
    const [recipe, setRecipe] = useState([]);


    // Google 認証関連
    class Gcp extends React.Component {
        state = { isSignedIn: null };
        componentDidMount() {
            window.gapi.load('client:auth2', () => {
            window.gapi.client.init({
                clientId: "650293790017-300enjcftr9qdm5gd1cu6vv38ln55jal.apps.googleusercontent.com", 
                scope: "email"
            }).then(() => {
                const auth = window.gapi.auth2.getAuthInstance();
                this.setState({ isSignedIn: auth.isSignedIn.get() });
            });
            });
        }
        renderAuth() {
            if (this.state.isSignedIn === null) {
            return <div></div>
            } else if (this.state.isSignedIn) {
                setSignin(true);
            return null;
            } else {
                setSignin(null);
            return <div>ログインされていません</div>;
            }
        }
        loginWithGoogle = () => {
            window.gapi.auth2.getAuthInstance().signIn();
        }
        logoutFromGoogle = () => {
            window.gapi.auth2.getAuthInstance().signOut();
        }
        render() {
            if(signin){
                return (
                    <div>
                        {this.renderAuth()}
                        <Button variant="contained" color="primary" onClick={this.logoutFromGoogle}>
                        ログアウト
                        </Button>
                    </div>
                );
            }else{
                return (
                    <div>
                        {this.renderAuth()}
                        <Button variant="contained" color="primary" onClick={
                            this.loginWithGoogle}>
                        ログイン
                        </Button>
                    </div>
                );
            }
        }
    }
    
    // Airtable内「TOP_ヘルメット治療患者一覧」→「名越用」からデータを取得
    useEffect(() => {
        let customerIdList = [];
        base(airtableTable).select({
            view: airtableView,
            sort: [{field:"発送・納品日", direction: "asc"},
                {field:"患者ID", direction: "asc"}]
        }).eachPage(function page(records, fetchNextPage) {
            for (let i = 0;i< records.length; i++){
                let cusData = [records[i].get('患者ID'), records[i].get('Record ID'), records[i].get('造形日'), records[i].get('磨き日'), records[i].get('槇町移動日'), records[i].get('クッション貼り日'), records[i].get('発送・納品日'), records[i].get('染色日'), records[i].get('造形機')]
                customerIdList.push(cusData);        
            }
            fetchNextPage();
        }, function done(err) {
            setCustomer(customerIdList);
            if (err) { console.error(err); return; }
        });
        base(airtableTableRecipe).select({
                maxRecords: 100,
                filterByFormula: "NOT({造形日} = '')",
                view: airtableViewPecipe
            }).eachPage(function page(records, fetchNextPage) {
                fetchNextPage();
                setRecipe(records);
            }, function done(err) {
                if (err) { console.error(err); return; }
            });
    }, []);

    
    // id欄内のチェックボックスにチェックすると、setstateする
    function SelectId({checkedId, selectId, setSelectId}) {
        const handleCheckBox = e => {
            if(selectId.includes(e.target.value)){
                setSelectId(selectId.filter(item => item !== e.target.value));
            }else{
                setSelectId([...selectId, e.target.value]);
            }
        }
        return (
            <Checkbox 
                color="primary"
                value={checkedId}
                onChange={handleCheckBox}
                checked={selectId.includes(checkedId)}
            />
        )
    }


    // 入力した日付と一致するレシピを探す
    function getRecipe(date) {
        const suitableRecipe = []; 
        for(const r in recipe){
            if(recipe[r].get('造形日') === date){
                suitableRecipe.push(recipe[r]);
            }
        }
        return suitableRecipe;
    }


    //レシピを紐づける
    function connectRecipe(recordId, printDate, polishDate) {
        if(multipleSelect){
            var selectedId = selectId;
        }else{
            var selectedId = [id];
        }
        for(var i in selectedId){
            base(airtableTable).update([
                {
                  "id": selectedId[i],
                  "fields": {
                    "レシピ": [recordId],
                    "造形日": printDate,
                    "磨き日": polishDate
                  }
                }
              ], function(err, records) {
                if (err) {
                  console.error(err);
                  return;
                }
            });
        }
        setShow(false);
    }

    
    // モーダルウィンドウ表示
    function Modal({show, setShow, date, setDate, selectId, setSelectId, selectRecipe, setSelectRecipe}){
        const closeModal = () => {
            setShow(false);
        }        
        if(show){
            if(selectRecipe){
                const matchRecipe = getRecipe(date);
                function Rparts(){
                    const recipeParts = [];
                    for(const i in matchRecipe){
                        var part = (
                            <p className={`${styles.recipeName}`} onClick={()=> {
                                connectRecipe(
                                    matchRecipe[i].id, 
                                    matchRecipe[i].get("造形日"), 
                                    matchRecipe[i].get("取り出し日")
                                );
                            }}>{matchRecipe[i].get('Name')}</p>
                        )
                        recipeParts.push(part);
                    }
                    return recipeParts;
                }
                return (
                    <div className={styles.overlay}>
                    <div className={styles.content}>
                        <h2 className={styles.recipeTitle}>レシピ一覧（※造形日による検索）</h2>
                        <Rparts />
                        <Button 
                            variant="contained" 
                            onClick={()=> {
                                closeModal();
                                setSelectRecipe(false);
                            }}
                        >Close</Button>
                    </div>
                </div>
                )
            }else{
                return (
                    <div className={styles.overlay}>
                    <div className={styles.content}>
                    <p onClick={() => {
                            ClickModal(id, date, 'print', selectId, multipleSelect);
                            setShow(false);
                        }} className={`${styles.btn} ${styles.blue}`}>造形</p>
                        <p onClick={() => {
                            ClickModal(id, date, 'polish', selectId, multipleSelect);
                            setShow(false);
                        }} className={`${styles.btn} ${styles.yellow}`}>磨き</p>
                        <p onClick={() => {
                            ClickModal(id, date, 'transfer', selectId, multipleSelect);
                            setShow(false);
                        }} className={`${styles.btn} ${styles.grey}`}>槇町移動</p>
                        <p  onClick={() => {
                            ClickModal(id, date, 'coloring', selectId, multipleSelect);
                            setShow(false);
                        }} className={`${styles.btn} ${styles.pink}`}>染色</p>
                        <p  onClick={() => {
                            ClickModal(id, date, 'foam', selectId, multipleSelect);
                            setShow(false);
                        }} className={`${styles.btn} ${styles.green}`}>クッション</p>
                        <p  onClick={() => {
                            ClickModal(id, date, 'recipe', selectId, multipleSelect);
                            setSelectRecipe(true);
                        }} className={`${styles.btn} ${styles.red}`}>レシピ</p>
                        <Button variant="contained" onClick={closeModal}>Close</Button>
                    </div>
                </div>
                )
            }
        }else{
            return null;
        }
    }


    // データ取得
    function delayGeatData(){
        (async () => {
            var customerIdList = [];
            base(airtableTable).select({
                view: airtableView,
                sort: [{field:"発送・納品日", direction: "asc"},
                   {field:"患者ID", direction: "asc"}]
            }).eachPage(function page(records, fetchNextPage) {
                for (let i = 0;i< records.length; i++){
                    let cusData = [
                                    records[i].get('患者ID'), 
                                    records[i].get('Record ID'), 
                                    records[i].get('造形日'), 
                                    records[i].get('磨き日'), 
                                    records[i].get('槇町移動日'), 
                                    records[i].get('クッション貼り日'), 
                                    records[i].get('発送・納品日'), 
                                    records[i].get('染色日'), 
                                    records[i].get('造形機')
                                ]
                    customerIdList.push(cusData);        
                }
                fetchNextPage();
            }, function done(err) {
                setCustomer(customerIdList);
                if (err) { console.error(err); return; }
            });
        })();
    };


    // モーダルのクリック後イベント
    function ClickModal(id, date, datename, selectId, multipleSelect){
        const updateDate = date;
        if(multipleSelect){
            var selectedId = selectId;
        }else{
            var selectedId = [id];
        }
        for(var i in selectedId){
            if(datename === 'print'){
                    base(airtableTable).update([
                        {
                            "id": selectedId[i],
                            "fields": {
                                '造形日': updateDate
                            }
                        }
                    ], function(err) {
                        if (err) {
                            console.error(err);
                            return;
                        }
                    });
                
            }else if(datename === 'polish'){
                    base(airtableTable).update([
                        {
                            "id": selectedId[i],
                            "fields": {
                                '磨き日': updateDate
                            }
                        }
                    ], function(err, records) {
                        if (err) {
                            console.error(err);
                            return;
                        }
                    });
            }else if(datename === 'transfer'){

                base(airtableTable).update([
                    {
                        "id": selectedId[i],
                        "fields": {
                            '槇町移動日': updateDate
                        }
                    }
                ], function(err, records) {
                    if (err) {
                        console.error(err);
                        return;
                    }
                });
            }else if(datename === 'foam'){
                base(airtableTable).update([
                    {
                        "id": selectedId[i],
                        "fields": {
                            'クッション貼り日': updateDate
                        }
                    }
                ], function(err, records) {
                    if (err) {
                        console.error(err);
                        return;
                    }
                });
            }else if(datename === 'coloring'){
                base(airtableTable).update([
                    {
                        "id": selectedId[i],
                        "fields": {
                            '染色日': updateDate
                        }
                    }
                ], function(err, records) {
                    if (err) {
                        console.error(err);
                        return;
                    }
                });
                   
            }else if(datename === 'recipe'){
                return(
                    <p>test</p>
                )
            }
            delayGeatData();
        }
    }


    // [Id, record_id, 造形日、磨き日、槇町移動日、槇町移動日AMPM、クッション貼り日、納品日、造形機、bool（日付入力=true or 未入力=false）]のデータセットを作成
    function IdData() {
        var list = [];
        var sumList = [];
        var sumPrint1 = {};
        var sumPrint2 = {};
        var sumPolish = {};
        var sumTransfer = {};
        var sumFoam = {};
        customer.forEach(function(record) {
            // 日付情報が入っているか確認
            var dateEmptyOrNot = true;
            if (record[2] == undefined || record[3] == undefined || record[4] == undefined || record[5] == undefined){
                dateEmptyOrNot = false;
            }
            record = [
                        record[0], 
                        record[1], 
                        record[2], 
                        record[3], 
                        record[4], 
                        record[5], 
                        record[6], 
                        record[7], 
                        record[8], 
                        dateEmptyOrNot
                    ]    
            list.push(record);
            
            if(dateToStr(record[8]) === '2号機'){
                var strDatePrint2 = 'D' + dateToStr(record[2]) + '_print2';
                if(sumPrint2[strDatePrint2]){
                    sumPrint2[strDatePrint2] += 1;
                }else{
                    sumPrint2[strDatePrint2] = 1;
                }
            }else{
                var strDatePrint1 = 'D' + dateToStr(record[2]) + '_print1';
                if(sumPrint1[strDatePrint1]){
                    sumPrint1[strDatePrint1] += 1;
                }else{
                    sumPrint1[strDatePrint1] = 1;
                }
            }
            var strDatePolish = 'D' + dateToStr(record[3]) + '_polish';
            var strDateTransfer = 'D' + dateToStr(record[4]) + '_transfer';
            var strDateFoam = 'D' + dateToStr(record[5]) + '_foam';
            if(sumPolish[strDatePolish]){
                sumPolish[strDatePolish] += 1;
            }else{
                sumPolish[strDatePolish] = 1;
            }
            if(sumTransfer[strDateTransfer]){
                sumTransfer[strDateTransfer] += 1;
            }else{
                sumTransfer[strDateTransfer] = 1;
            }
            if(sumFoam[strDateFoam]){
                sumFoam[strDateFoam] += 1;
            }else{
                sumFoam[strDateFoam] = 1;
            }
        });
        sumList.push(sumPrint1);
        sumList.push(sumPrint2);
        sumList.push(sumPolish);
        sumList.push(sumTransfer);
        sumList.push(sumFoam);
        return [list, sumList];
    }


    // 表上部に表示させる合計数の計算
    function AddSumCount() {
        const sumList = IdData()[1];
        const sumPrint1 = sumList[0];
        const sumPrint2 = sumList[1];
        const sumPolish = sumList[2];
        const sumTransfer = sumList[3];
        const sumFoam = sumList[4];
        const queryset = key => document.querySelector('#' + key);
        for(let keyPrint1 in sumPrint1){
            if(queryset(keyPrint1) != null){
                queryset(keyPrint1).textContent = sumPrint1[keyPrint1];
            }
        }
        for(let keyPrint2 in sumPrint2){
            if(queryset(keyPrint2) != null){
                queryset(keyPrint2).textContent = sumPrint2[keyPrint2];
            }
        }
        for(let keyPolish in sumPolish){
            if(queryset(keyPolish) != null){
                queryset(keyPolish).textContent = sumPolish[keyPolish];
            }
        }
        for(let keyTransfer in sumTransfer){
            if(queryset(keyTransfer) != null){
                queryset(keyTransfer).textContent = sumTransfer[keyTransfer];
            }
        }
        for(let keyFoam in sumFoam){
            if(queryset(keyFoam) != null){
                queryset(keyFoam).textContent = sumFoam[keyFoam];
            }
        }
        return null;
    }


    // 日付、曜日データが格納されたデータセットを作成
    function CalendarParts(id, recordId){
        const thIdColumn = 
            <th 
                width='150' 
                className={`${styles.thead} ${styles.th_head} ${styles.th_title}`}
            >患者ID</th>;
        var dateArray = [thIdColumn]; 
        var tdArray = []; 
        const colspan = 1; // 表の区切り値
        
        // 日時・曜日表示の作成
        const start = new Date(startDate);
        const end = new Date(endDate);
        for(var d = start; d < end; d.setDate(d.getDate()+1)){
            // 日付表示の作成
            const dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ][d.getDay()] ;
            var toDoubleDigits = function(num) {
                num += "";
                if (num.length === 1) {
                    num = "0" + num;
                }
                return num;     
            };
            let oneDay = [
                d.getFullYear(), 
                toDoubleDigits(d.getMonth() + 1), 
                toDoubleDigits(d.getDate()), 
                dayOfWeekStr
            ];
            const day = oneDay[0] + '-' + oneDay[1] + '-' + oneDay[2];
            if(d.getDay() === 0 || d.getDay() === 6){
                dateArray.push(
                    <th 
                        onClick={()=>{
                            setShow(true);
                            setDate(day);
                            setMultipleSelect(true);
                        }} 
                        className={`
                            ${styles.thead_week} 
                            ${styles.th_head} 
                            ${styles.th_slide}
                        `}>
                        {oneDay[1]}/{oneDay[2]}<br/>{oneDay[3]}
                    </th>
                );
            }else{
                dateArray.push(
                    <th 
                        onClick={()=>{
                            setShow(true);
                            setDate(day);
                            setMultipleSelect(true);
                        }} 
                        className={`
                            ${styles.thead} 
                            ${styles.th_head} 
                            ${styles.th_slide}
                        `}
                    >
                    {oneDay[1]}/{oneDay[2]}<br/>{oneDay[3]}
                    </th>
                );
            }
            const tdComponent = []; 
            let i = 0;
            while(i < colspan){
                const classDate = 'D' + oneDay[0] + oneDay[1] + oneDay[2];  
                var tdParts = <td className={`${classDate} ${id} ${styles.td}`} onClick={ () => {
                    setShow(true);
                    setId(recordId);
                    setDate(day);
                    setQuery(id);
                }}></td>;
                tdComponent.push(tdParts);
                i += 1;
            }
            tdArray.push(
                tdComponent
            );
        };   
        return [tdArray, dateArray]
    }


    // 患者ごとの行作成
    // 患者へ日付ラベルを挿入
    function CalendarLine(){
        var AllCustomer = [];
        for(const i of IdData()[0]){
            var tdArray = CalendarParts(i[0], i[1])[0];
            var dateEmptyBool = i[9];
            console.log();
                
            function EachCustomerTh () {
                return (
                    <th className={`${styles.th_slide} ${styles.td} ${styles.tdId}`}>
                        <div className={styles.th_checkbox}>
                            <div className={styles.th_check}>
                                <FormControlLabel 
                                    control={<SelectId 
                                                checkedId={i[1]} 
                                                selectId={selectId} 
                                                setSelectId={setSelectId}
                                            />}
                                    label={<span className={styles.idName}>{i[0]}</span>} /> 
                            </div>
                        </div>
                    </th>
                );
            }

            // データ未入力ならラベリング
            if(dateEmptyBool){
                var eachCustomer = (
                    <tr id={i[0]} >
                        <EachCustomerTh/>
                        {tdArray}
                    </tr>
                );
            }else{
                var eachCustomer = (
                    <tr id={i[0]} className={styles.emptysell}>
                        <EachCustomerTh/>
                        {tdArray}
                    </tr>
                );
            }

            AllCustomer.push(eachCustomer);
        }
        return AllCustomer;
    }

    function ClassDate(d) {
        let oneDay = [d.getFullYear(), toDoubleDigits(d.getMonth() + 1), toDoubleDigits(d.getDate())];
        const classDate = 'D' + oneDay[0] + oneDay[1] + oneDay[2]; 
        return classDate;
    }

    //合計数表示の作成
    function SumArray() {
        var sumPrintArray = [];
        var sumPolishArray = [];
        var sumTransferArray = [];
        var sumFoamArray = [];
        const start = new Date(startDate);
        const end = new Date(endDate);
        for(var d = start; d < end; d.setDate(d.getDate()+1)){
            const classDate = ClassDate(d); 
            // 合計表示の作成
            sumPrintArray.push(
                <th 
                    className={`
                        ${styles.th_head} 
                        ${styles.th_slide} 
                        ${styles.sumTh0}
                    `}>
                    <div 
                        className={styles.zoukeiTh} 
                        id={classDate + '_print1'}
                    >
                    0
                    </div>
                    <div 
                        className={styles.zoukeiTh} 
                        id={classDate + '_print2'}
                    >
                    0
                    </div>
                </th>
            )
            sumPolishArray.push(
                <th className={`
                    ${styles.th_head} 
                    ${styles.th_slide} 
                    ${styles.sumTh1}`} 
                    id={classDate + '_polish'}
                >0</th>
            )
            sumTransferArray.push(
                <th className={`
                    ${styles.th_head} 
                    ${styles.th_slide} 
                    ${styles.sumTh2}`} 
                    id={classDate + '_transfer'}
                >0</th>
                )
            sumFoamArray.push(
                <th className={`
                    ${styles.th_head} 
                    ${styles.th_slide} 
                    ${styles.sumTh3}
                    `} 
                    id={classDate + '_foam'}
                >0</th>
            )
        }
        return [sumPrintArray, sumPolishArray, sumTransferArray, sumFoamArray];
    }
    

    // カレンダー化
    function Calendar(){
        const AllCustomer = CalendarLine();
        const dateArray = CalendarParts()[1];
        const sumPrintArray = SumArray()[0];
        const sumPolishArray = SumArray()[1];
        const sumTransferArray = SumArray()[2];
        const sumFoamArray = SumArray()[3];
        function ZoukeiThCom(){
            return(
                <th 
                    className={`
                    ${styles.th_slide} 
                    ${styles.th_head} 
                    ${styles.th_title} 
                    ${styles.sumTh0} 
                    ${styles.thinBlue}
                `}>造形</th>
            );
        } 
        function PolishThCom(){
            return(
                <th 
                    className={`
                    ${styles.th_slide} 
                    ${styles.th_head} 
                    ${styles.th_title} 
                    ${styles.sumTh1} 
                    ${styles.thinBlue}
                `}>磨き</th>
            )
        }
        function TransferThCom(){
            return(
                <th 
                    className={`
                    ${styles.th_slide} 
                    ${styles.th_head} 
                    ${styles.th_title} 
                    ${styles.sumTh2} 
                    ${styles.thinBlue}
                `}>移動</th>
            )
        }
        function FoamThCom(){
            return(
                <th 
                    className={`
                    ${styles.th_slide} 
                    ${styles.th_head} 
                    ${styles.th_title} 
                    ${styles.sumTh3} 
                    ${styles.thinBlue}
                `}>貼り</th>
            )
        }

        return (
            <table border='1' className={styles.table}>
                <thead>
                    <tr className={styles.sumTh}>
                        <ZoukeiThCom/>
                        {sumPrintArray}
                    </tr>
                    <tr className={styles.sumTh}>
                        <PolishThCom/>
                        {sumPolishArray}
                    </tr>
                    <tr className={styles.sumTh}>
                        <TransferThCom/>
                        {sumTransferArray}
                    </tr>
                    <tr className={styles.sumTh}>
                        <FoamThCom/>
                        {sumFoamArray}
                    </tr>
                    <tr> 
                        {dateArray}
                    </tr> 
                </thead>
                <tbody>
                    {AllCustomer}
                </tbody>
            </table>
        );
    }
    

    // レシピ作成画面
    function CreateRecipe(){
        function OpenCreateWindow() {
            const [name, setName] = useState("");
            const day = new Date();
            const today = String(day.getFullYear() + "-" + toDoubleDigits(day.getMonth()+1) + "-" + toDoubleDigits(day.getDate())); 
            const [datePrint, setDatePrint] = useState(today);
            const [datePickup, setDatePickup] = useState(today);
            const [printer, setPrinter] = useState("");
            const [coolingBox, setCooligBox] = useState("");
            const [error, setEroor] = useState(false);

            const closeWindow = () =>{
                setShowRecipe('close');
            }
            const handleChange = (event) => {
                switch(event.target.name) {
                    case 'name':
                        setName(event.target.value);
                        break;
                    case 'datePrint':
                        setDatePrint(event.target.value);
                        break;
                    case 'datePickup':
                        setDatePickup(event.target.value);                    
                        break;
                    case 'printer':
                        setPrinter(event.target.value);
                        break;
                    case 'coolingBox':
                        setCooligBox(event.target.value);
                        break;
                }
            }
            const handleSubmit = () =>{
                if(name === "" || printer === "" || coolingBox === ""){
                    setEroor(true);
                }else{
                    setEroor(false);
                    setShowRecipe('done');
                    CreateRecipeAPI();
                }
            }
            function ErrorMessage({bool}) {
                if(bool){
                    return (
                        <div 
                            className={`
                                ${styles.noticeMessage} 
                                ${styles.red}
                            `}>
                            未入力の項目があります
                        </div>
                    )
                }else{ return null; }
            }
            function CreateRecipeAPI(){
                const strPrinter = () =>{
                    if(printer === 1){
                        return "1号機";
                    }else if(printer === 2){
                        return "2号機";
                    }else{
                        return null;
                    }
                }
                const strCoolingBox = () =>{
                    if(coolingBox === 1){
                        return "1号機";
                    }else if(coolingBox === 2){
                        return "2号機";
                    }else{
                        return null;
                    }
                }
                base(airtableTableRecipe).create([
                    {
                      "fields": {
                        "Name": name,
                        "造形日": datePrint,
                        "取り出し日": datePickup,
                        "造形機": `${strPrinter()}`,
                        "クーリングボックス": `${strCoolingBox()}`
                      }
                    }
                  ], function(err, records) {
                    if (err) {
                      console.error(err);
                      return;
                    }
                    records.forEach(function (record) {
                      console.log(record.getId());
                    });
                });
            }

            if (showRecipe === 'open'){


            return (
                <div className={styles.overlay}>
                <div className={styles.content}>
                    <h2 className={styles.recipeTitle}>造形レシピ新規作成</h2>
                    <form>
                        <div className={styles.recipeBox}>
                            <p className={styles.subTitle}>レシピ名</p>   
                            <Input 
                                type="text" 
                                name="name" 
                                value={name} 
                                onChange={handleChange}
                            />
                        </div>
                        <div className={styles.recipeBox}>
                            <TextField
                                id="startDate"
                                label="造形日"
                                type="date"
                                className={classes.textField}
                                name="datePrint"
                                value={datePrint}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <TextField
                                id="startDate"
                                label="取り出し日"
                                type="date"
                                className={classes.textField}
                                name="datePickup"
                                value={datePickup}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div> 
                        <div className={styles.recipeBox}>
                            <div className={styles.recipeSmallBox}>
                                <p>造形機</p>
                                <Select 
                                    name="printer" 
                                    value={printer} 
                                    onChange={handleChange}
                                >
                                    <MenuItem value={1}>1号機</MenuItem>
                                    <MenuItem value={2}>2号機</MenuItem>
                                </Select>   
                            </div>
                            <div className={styles.recipeSmallBox}>
                                <p>クーリングボックス</p>
                                <Select name="coolingBox" value={coolingBox} onChange={handleChange}>
                                    <MenuItem value={1}>1号機</MenuItem>
                                    <MenuItem value={2}>2号機</MenuItem>
                                </Select>  
                            </div>
                        </div> 
                        <ErrorMessage bool={error}/>
                        <div className={styles.buttonBox}>
                            <div className={styles.windowButtonBox}>
                                <Button 
                                    variant="contained" 
                                    onClick={() => closeWindow()
                                }>閉じる</Button>
                            </div>
                            <div className={styles.windowButtonBox}>
                                <Button 
                                    variant="contained" 
                                    color="secondary" 
                                    onClick={() => handleSubmit()
                                }>
                                    レシピ作成
                                </Button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            )

            }else if(showRecipe === 'done'){
                return (
                    <div className={styles.overlay}>
                    <div className={styles.content}>
                        <h2 className={styles.recipeTitle}>造形レシピ新規作成</h2>
                        <p className={`${styles.noticeMessage} ${styles.green}`}>レシピ作成が完了しました！</p> 
                        <div className={styles.buttonBox}>
                            <Button variant="contained" onClick={() => closeWindow()}>Close</Button>
                        </div>  
                    </div>
                    </div>
                )
            }else{
                return null;
            }
        
        }
        return (
            <div className={styles.recipeWrap}>
                <Button variant="contained" color='secondary' onClick={() => {setShowRecipe('open')}} >レシピの作成</Button>
                <OpenCreateWindow showRecipe={showRecipe} setShowRecipe={setShowRecipe}/>
            </div>
        );
    }


    // ヘッダー表示
    function Header() {
        return(
            <div className={styles.header}>
                <div className={styles.header_box}>
                    <form className={classes.textField} noValidate>
                        <TextField
                            id="startDate"
                            label="開始日"
                            type="date"
                            value={startDate}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setStartDate(event.target.value)}
                        />
                        <span className={styles.space}></span>
                        <TextField
                            id="endDate"
                            label="終了日"
                            type="date"
                            value={endDate}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setEndDate(event.target.value)}
                        />
                        <Button variant="contained" color="primary" onClick={() => {
                            setSelectId([]);
                        }}>選択解除</Button>
                    </form>     
                    <CreateRecipe />
                </div>
            </div>
        );
    }

    // ラベル挿入
    // 造形日を挿入
    // function AddLabel() {
    function dateToStr(params) {
        var array = String(params).split('-');
        var str = "";
        for(const i of array){
            str += i; 
        }
        return str;
    }

    // ラベルの追加
    function appendLabel(index, selectorId, selector, label){
        if(index !== undefined){
            if(document.getElementById(selectorId).querySelector(selector) != null){
                document.getElementById(selectorId).querySelector(selector).append(label);
            }
        }
    }

    useEffect(() => {
        if(signin){
            for(const i of IdData()[0]){
                const selectId = String(i[0]);
                const selectDateZoukei = String(dateToStr(i[2]));
                const selectDatePolish = String(dateToStr(i[3]));
                const selectDateTransfer = String(dateToStr(i[4]));
                const selectDateFoam = String(dateToStr(i[5]));
                const selectDateDeliver = String(dateToStr(i[6]));
                const selectDateColoring = String(dateToStr(i[7]));
                const printMachineUnmber = () => {
                    if(String(dateToStr(i[8])) === '1号機'){
                        return 1;
                    }else if(String(dateToStr(i[8])) === '2号機'){
                        return 2;
                    }
                }
                appendLabel(i[6], selectId, '.D' + selectDateDeliver, LabelDeliver());
                appendLabel(i[2], selectId, '.D' + selectDateZoukei, LabelPrint(printMachineUnmber()));
                appendLabel(i[3], selectId, '.D' + selectDatePolish, LabelPolish());
                appendLabel(i[4], selectId, '.D' + selectDateTransfer, LabelTransfer());
                appendLabel(i[5], selectId, '.D' + selectDateFoam, LabelFoam());
                appendLabel(i[7], selectId, '.D' +  selectDateColoring, LabelColoring());
            }    
            AddSumCount();
        }
    });

    if(signin){
        return (
            <div className={styles.app}>
                <div className={styles.titleBox}>
                    <h1 className={styles.title}>ヘルメットスケジュール管理（β版）</h1>
                    <Gcp />
                </div>
                <div id='test'></div>
                <div className='test'/>
                <Header/>
                <div className={styles.wrapTable}>
                    <Calendar/>
                    <Modal 
                        show={show} 
                        setShow={setShow} 
                        date={date} 
                        setDate={setDate} 
                        selectId={selectId} 
                        setSelectId={setSelectId} 
                        selectRecipe={selectRecipe} 
                        setSelectRecipe={setSelectRecipe}
                    />
                </div>
            </div>
        );
    }else{
        return(
            <div className={styles.app}>
                <div>
                    <h1 className={styles.title}>ヘルメットスケジュール管理（β版）</h1>
                </div>
                <Gcp />
                <p>利用するにはログインしてください</p>
            </div>
        );
    }   
}


export default App;


